// extracted by mini-css-extract-plugin
export default {"login_wrapper":"LoginPage_login_wrapper__Syk0z","logo":"LoginPage_logo__gAiI7","login_button":"LoginPage_login_button__G5TeO"};